/**
 * Reduces a URL to its short brand label — the first hostname segment, with
 * `www.` stripped and the TLD dropped. Returns `null` when the input is not a
 * parseable URL.
 *
 * @example
 * shortHostname('https://facebook.com/johndoe') // 'facebook'
 * shortHostname('https://www.linkedin.com/in/x') // 'linkedin'
 */
export const shortHostname = (
  url: string | null | undefined,
): string | null => {
  if (!url) {
    return null;
  }
  try {
    const host = new URL(url).hostname.replace(/^www\./, '');
    const label = host.split('.')[0];
    return label || host;
  } catch {
    return null;
  }
};
